import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fmtAmount, fmtCompact } from "@/lib/format";

export const money = (m, compact = false) => {
  const e = Object.entries(m || {}).filter(([, v]) => v);
  return e.length ? e.map(([c, v]) => (compact ? fmtCompact(v, c) : fmtAmount(v, c))).join(" + ") : "—";
};

export const STATUS = {
  paid: { label: "Paid", cls: "bg-emerald-50 border-emerald-200 text-emerald-800", dot: "bg-emerald-500" },
  overdue: { label: "Overdue", cls: "bg-rose-50 border-rose-200 text-rose-800", dot: "bg-rose-500" },
  due_soon: { label: "Due soon", cls: "bg-amber-50 border-amber-200 text-amber-800", dot: "bg-amber-500" },
  partial: { label: "Part paid", cls: "bg-amber-50 border-amber-200 text-amber-800", dot: "bg-amber-500" },
  pending: { label: "Upcoming", cls: "bg-blue-50 border-blue-200 text-blue-800", dot: "bg-blue-500" },
};

export const Legend = () => (
  <div className="flex flex-wrap gap-3 text-[11px] text-slate-600" data-testid="ob-board-legend">
    {["paid", "overdue", "due_soon", "pending"].map((k) => <span key={k} className="inline-flex items-center gap-1.5"><span className={`w-2 h-2 rounded-full ${STATUS[k].dot}`} />{STATUS[k].label}</span>)}
  </div>
);

const Sel = ({ value, onChange, all, options, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid} className="h-9 w-auto min-w-[150px] bg-white"><SelectValue /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{all}</SelectItem>
      {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const BoardFilters = ({ f, setF, facets }) => {
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="ob-board-filters">
      <Sel testid="ob-filter-entity" value={f.entity} onChange={set("entity")} all="All entities / clients"
        options={[...(facets?.entities || []).map((e) => ({ value: e, label: e })), { value: "__none__", label: "No entity" }]} />
      <Sel testid="ob-filter-category" value={f.category} onChange={set("category")} all="All categories" options={(facets?.categories || []).map((c) => ({ value: c, label: c }))} />
      <Sel testid="ob-filter-mode" value={f.payment_mode} onChange={set("payment_mode")} all="All payment modes" options={[{ value: "auto", label: "Auto debit" }, { value: "manual", label: "Manual" }]} />
    </div>
  );
};
